export const YES = 'Yes';
export const NO = 'No';

export const yesNoOptions = [
    {display: 'Please select', value: ''},
    {display: YES, value: YES},
    {display: NO, value: NO}
];

